exports = module.exports = require("../../../_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-cell-group {\n  background-color: #fff;\n}\n\n.van-cell-group--inset {\n  margin: 0 0.426667rem;\n  overflow: hidden;\n  border-radius: 0.213333rem;\n}\n\n.van-cell-group__title {\n  padding: 0.426667rem 0.426667rem 0.213333rem;\n  color: #969799;\n  font-size: 0.373333rem;\n  line-height: 0.426667rem;\n}\n\n.van-cell-group__title--inset {\n  padding: 0.426667rem 0.426667rem 0.213333rem 0.853333rem;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_px2rem-loader@0.1.9@px2rem-loader?{"remUnit":37.5}!./~/_vant@2.13.2@vant/lib/cell-group/index.css
// module id = 217
// module chunks = 320 321